import { request } from "../utils/request.js"

export const customizePurchaseOrder_exportForManage = (pojo, args) => request({
    url: 'customizePurchaseOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findPageForManage = (pojo, args) => request({
    url: 'customizePurchaseOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findPageListForManage = (pojo, args) => request({
    url: 'customizePurchaseOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'customizePurchaseOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'customizePurchaseOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findPageForSelect = (pojo, args) => request({
    url: 'customizePurchaseOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findPageListForSelect = (pojo, args) => request({
    url: 'customizePurchaseOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const customizePurchaseOrder_saveIntoDraft = (pojo, args) => request({
    url: 'customizePurchaseOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'customizePurchaseOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_update = (pojo, args) => request({
    url: 'customizePurchaseOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_updateAndSubmit = (pojo, args) => request({
    url: 'customizePurchaseOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_submitById = (id, args) => request({
    url: 'customizePurchaseOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_deleteById = (id, args) => request({
    url: 'customizePurchaseOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_approval = (pojo, args) => request({
    url: 'customizePurchaseOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizePurchaseOrder_findById = (id, args) => request({
    url: 'customizePurchaseOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findByIdIn = (params, args) => request({
    url: 'customizePurchaseOrder/findByIdIn',
    method: 'POST',
    params: params,
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_findVoById = (id, args) => request({
    url: 'customizePurchaseOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizePurchaseOrder_generatePrintPdf = (pojo, args) => request({
    url: 'customizePurchaseOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})




// WEBPACK FOOTER //
// ./src/api/customizePurchaseOrder.js